module.exports = __webpack_public_path__ + "img/Metastasis-OVCA_10X_WTA.01ad3453.png";